import { useQuery } from 'react-query';

import { api } from 'api';
import { responseWithData } from 'utils';

import { Backend } from 'api/endpoints';

// Products

export const useProducts = () =>
	useQuery(['products'], () =>
		api().get('public/products/').json<Backend.Product[]>(),
	);

export const useActiveLicences = () =>
	useQuery(['products', 'active-licences'], () =>
		api().get('public/products/active-licences').json<Backend.Product[]>(),
	);

// Offers for homepage

export const useNewestOffers = () =>
	useQuery('public/offers/find-newest', () =>
		api().get('public/offers/find-newest').json<Backend.OfferPublic[]>(),
	);

export const getPublicLogoUrl = async (offerId: string) => {
	try {
		return (await api().get(`public/offers/logo/${offerId}`))
			? `/api/jch/public/offers/logo/${offerId}`
			: undefined;
	} catch (error) {
		return undefined;
	}
};

// Registration

export const aresLookup = (ic: string) =>
	responseWithData<Backend.AresResponse>(
		api().get(`public/registrations/company/ares/${ic}`),
	);

export const checkCompanyEmail = (email: string) =>
	responseWithData<boolean>(
		api().get(`public/registrations/company/check-email/${email}`),
	);

export const checkCompanyIco = (ico: string) =>
	responseWithData<boolean>(
		api().get(`public/registrations/company/check-ic/${ico}`),
	);

export const registerCompany = (
	company: Backend.CompanyRegistrationDto,
	university: Backend.University,
) =>
	api().post('public/registrations/company', {
		json: company,
		searchParams: { university },
	});

export const checkAlumnusUsername = (username: string) =>
	responseWithData<boolean>(
		api().get(`public/registrations/alumnus/check-name/${username}`),
	);

export const registerAlumnus = (alumnus: Backend.AlumnusRegistrationDto) =>
	responseWithData<{ message: string }>(
		api().post('public/registrations/alumnus', {
			json: alumnus,
			throwHttpErrors: false,
		}),
		async r =>
			r.ok ? { message: 'OK' } : ((await r.json()) as { message: string }),
	);

//  Statistics

export const useHomepageStatistics = () =>
	useQuery(['statistics'], () =>
		api().get('public/statistics/homepage').json<Backend.Statistics[]>(),
	);
